<template>
  <div class="bg_home">
    <app-home-banner :filteredAnnouncement="filteredAnnouncement"></app-home-banner>

    <app-game-tab-holder></app-game-tab-holder>
    <app-referral-home-banner></app-referral-home-banner>
    <app-daily-check-in-home-banner></app-daily-check-in-home-banner>
    <app-official-video-home-banner></app-official-video-home-banner>
    <!--    <app-home-highlight></app-home-highlight>-->

    <!-- <img :src="wof.event_setting.home_gif_url" alt="wof" width="72" height="70" class="wofClass" @click="navigateWOFPage()"/>
    <img :src="'/static/image/home/downloadAPK_float.gif'" width="72" height="72" v-if="platform=='desktop'" class="downloadClientClass" @click="downloadAPK()"/> -->
  </div>
</template>

<script>
import { DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
import AppHomeBanner from '@/components/home/HomeBanner.vue'
import RecentWinner from '@/components/home/RecentWinner'
import AppReferralHomeBanner from '@/components/home/ReferralHomeBanner'
import AppDailyCheckInHomeBanner from '@/components/home/DailyCheckIn'
import AppOfficialVideoHomeBanner from '@/components/home/OfficialVideo.vue'
import RecentWithdrawal from '@/components/home/RecentWithdrawal'
import RecentDeposit from '@/components/home/RecentDeposit'
import AppPlayWithUs from '@/components/home/PlayWithUs.vue'
import { AnnouncementType } from '@/constants/enums'
import { uiHelper, locale } from '@/util'
import { ANNOUNCEMENT_LIST } from '@/store/announcement.module'
import { SHARED, SESSION } from '@/constants/constants'
// import AppSportCasinoHolder from '@/components/home/SportCasinoHolder.vue'
// import NavSlot from '@/assets/svg/rng_icon.svg'
// import NavCasino from '@/assets/svg/ld_icon.svg'
// import NavAll from '@/assets/svg/all_icon.svg'
// import NavSports from '@/assets/svg/sportsbook_icon.svg'
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
import { MEMBER_DETAIL } from '@/store/member.module'
import AppHomeHighlight from '@/components/home/Highlight.vue'
import AppGameTabHolder from '@/components/home/GameTabHolder.vue'
import AppReferral from '@/components/member/referral'
import { WHEEL_MODULE } from '@/store/wheel.module'
import { GRAB_COIN_SETTING } from '@/store/bonus.module'
import { REFERRAL_GET_OVERVIEW } from '@/store/referral.module'

export default {
  name: 'Home',
  // metaInfo: {
  //   title: `${locale.getMessage('meta.default_title')}`,
  //   titleTemplate: `%s`,
  //   meta: [{charset: 'utf-8'}, {
  //     name: 'description',
  //     content: `${locale.getMessage('meta.home_description')}`
  //   }, {name: 'keyword', content: `${locale.getMessage('meta.home_keyword')}`}],
  //   link: [
  //     {rel: 'canonical', href: `https://www.nagad88.io/en-BD/home`}
  //   ]
  // },
  components: {
    Hooper,
    Slide,
    HooperPagination,
    RecentWinner,
    AppHomeBanner,
    AppPlayWithUs,
    RecentDeposit,
    RecentWithdrawal,
    // AppSportCasinoHolder,
    // NavSlot,
    // NavCasino,
    // NavAll,
    // NavSports,
    AppHomeHighlight,
    AppGameTabHolder,
    AppReferral,
    AppReferralHomeBanner,
    AppDailyCheckInHomeBanner,
    AppOfficialVideoHomeBanner
  },
  data: () => ({
    showCoin: true,
    selectionType: 'all',
    storageAnnouncement: null,
    currentLanguage: uiHelper.getLanguage(),
    filteredAnnouncement: [],
    isAndroid: uiHelper.isAndroid(),
    platform: uiHelper.getPlatform()
  }),
  computed: {
    grabCoin() {
      let d = this.$store.state.bonus.grabCoinSettings
      return d
    },
    wof() {
      return this.$store.state.wheel.wheel
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    announcementList() {
      return this.$store.state.announcement.announcements
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    }
  },
  watch: {
    announcementList() {
      this.storageAnnouncement = this.$store.state.announcement.announcements
      this.populateAnnouncement(this.storageAnnouncement)
    }
  },
  created() {
    this.checkShouldHideCoin()
    this.getGrabCoinSetting()
    this.getWOF()
    this.checkIncomingAction()
    this.getAnnouncement()
    this.getMemberDetail()
    this.checkReferCode()
    this.metaTag()
  },
  beforeRouteLeave(to, from, next) {
    uiHelper.setMetaTag('og:title', '')
    uiHelper.setMetaTag('og:description', '')
    next()
  },
  methods: {
    downloadAPK() {
      uiHelper.downloadAPK()
    },
    metaTag() {
      uiHelper.setMetaTag('url', window.location.href)
      uiHelper.setMetaTag('og:url', window.location.href)
      uiHelper.setMetaTag('og:type', 'website')
      uiHelper.setMetaTag('og:site_name', 'Nagad88')
      uiHelper.setMetaTag('og:image', window.location.href + 'static/image/home/logo.webp')
      uiHelper.setMetaTag('og:title', `${locale.getMessage('meta.home_og_title')}`)
      uiHelper.setMetaTag('og:description', `${locale.getMessage('meta.home_og_description')}`)
      uiHelper.setMetaTag('keywords', `${locale.getMessage('meta.home_keyword')}`)
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      uiHelper.setMetaTag('copyright', `� ` + currentYear + `. Copyright Nagad88`)

      const domain_all = window.location.hostname.toLowerCase()

      // Update the og:title content based on the domain
      if (domain_all.includes('nagad88.online')) {
        uiHelper.setTitle(`${locale.getMessage('meta.nagad_online_title')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.nagad_online_description')}`)
      } else if (domain_all.includes('localhost')) {
        uiHelper.setTitle(`${locale.getMessage('meta.nagad_app_title')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.nagad_app_description')}`)
      } else {
        uiHelper.setTitle(`${locale.getMessage('meta.home_title')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.home_description')}`)
      }
      const currentUrl = window.location.href
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      const Links = `https://${domain}`
      const Linksen = `https://${domain}/en-BD`
      const Linksbn = `https://${domain}/bn-BD`
      uiHelper.setCanonical(currentUrl)
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)

      // uiHelper.setHreflangLinks(currentUrl)
      // uiHelper.setHreflangLinksen('https://www.nagad88.io')
      // uiHelper.setHreflangLinksbd('https://www.nagad88.io')
      // uiHelper.setTitle(`${locale.getMessage('meta.home_title')}`)
    },
    checkReferCode() {
      let af = this.$route.query.af
      let r = this.$route.query.refer_code
      let u_s = this.$route.query.utm_source
      let u_m = this.$route.query.utm_medium
      let u_c = this.$route.query.utm_campaign
      let s2 = this.$route.query.s2
      let stag = this.$route.query.stag
      let tracking_link = this.$route.query.tracking_link
      let fbPixelId = this.$route.query.fbPixelId

      try {
        let old_af = uiHelper.getCookie(SESSION.AFF_CODE)
        if (typeof old_af != 'undefined' && old_af != '' && old_af != null) {
          if (old_af !== af) {
            //if old af not match clear all pixel info.
            uiHelper.removeCookie(SESSION.PID)
            uiHelper.removeCookie(SESSION.CLICKID)
            uiHelper.removeCookie(SESSION.UTM_SOURCE)
            uiHelper.removeCookie(SESSION.UTM_MEDIUM)
            uiHelper.removeCookie(SESSION.UTM_CAMPAIGN)
            uiHelper.removeCookie(SESSION.UTM_S2)
          }
        }
      } catch (err) {
        console.log(err)
      }

      var domain = window.location.hostname
      var wwwDomain = domain.replace(/^www\./, '') // Remove "www." if it exists

      // Create a dictionary to map domains to expiration days
      var expirationDaysByDomain = {
        //first array = third party aff / second = agent code
        'nagad88.com': [30, 30],
        'nagad88.app': [30, 30],
        'nagad88.net': [30, 365],
        'nagad88.online': [30, 30],
        'nagad88.org': [30, 30],
        'nagad88.group': [30, 365],
        'nagad88.casino': [30, 30],
        'nagad88.vip': [30, 30],
        'nagad88.pro': [30, 30],
        'nagad88.co': [30, 30],
        'nagad88.club': [30, 30],
        'nagad88.live': [30, 30],
        'nagad88.io': [30, 30]
        // Add more domains and expiration days as needed
      }

      // Set the expiration day based on the domain
      var expirationDaysArray = expirationDaysByDomain[wwwDomain]

      // Default expiration (e.g., 1 day) if the domain is not in the dictionary or the array is not valid
      var expirationDaysThirdParty = 1
      var expirationDaysAgent = 365

      if (expirationDaysArray && expirationDaysArray.length === 2) {
        // Your logic to choose between short and long expiration here
        // For example, you can check some condition to decide:
        expirationDaysThirdParty = expirationDaysArray[0] // Use short expiration
        expirationDaysAgent = expirationDaysArray[1]
      }
      if (typeof fbPixelId != 'undefined' && fbPixelId != '' && fbPixelId != null) {
        uiHelper.setCookie(SESSION.FB_PIXEL_CODE, fbPixelId, expirationDaysAgent)
      }
      if (typeof stag != 'undefined' && stag != '' && stag != null) {
        uiHelper.setCookie(SESSION.STAG, stag, expirationDaysThirdParty)
      }
      if (typeof tracking_link != 'undefined' && tracking_link != '' && tracking_link != null) {
        uiHelper.setCookie(SESSION.TRACKING_LINK, tracking_link, expirationDaysThirdParty)
      }
      if (typeof u_s != 'undefined' && u_s != '' && u_s != null) {
        uiHelper.setCookie(SESSION.UTM_SOURCE, u_s, expirationDaysThirdParty)
      }
      if (typeof u_m != 'undefined' && u_m != '' && u_m != null) {
        uiHelper.setCookie(SESSION.UTM_MEDIUM, u_m, expirationDaysThirdParty)
      }
      if (typeof u_c != 'undefined' && u_c != '' && u_c != null) {
        uiHelper.setCookie(SESSION.UTM_CAMPAIGN, u_c, expirationDaysThirdParty)
      }
      if (typeof s2 != 'undefined' && s2 != '' && s2 != null) {
        uiHelper.setCookie(SESSION.UTM_S2, s2, expirationDaysThirdParty)
      }
      if (typeof af != 'undefined' && af != '' && af != null) {
        uiHelper.setCookie(SESSION.AFF_CODE, af, expirationDaysAgent)
        this.openRegisterDialog()
      } else {
        if (typeof r != 'undefined' && r != '' && r != null) {
          uiHelper.setCookie(SESSION.REFER_CODE, r, expirationDaysAgent)
          this.openRegisterDialog()
        }
      }
    },
    getGrabCoinSetting() {
      let filter = {
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${GRAB_COIN_SETTING}`, { filter })
    },
    checkShouldHideCoin() {
      if (typeof uiHelper.getCookie(SESSION.HIDE_COIN) != 'undefined' && uiHelper.getCookie(SESSION.HIDE_COIN) == 1) {
        this.showCoin = false
      } else {
        this.showCoin = true
      }
    },
    dontShowMeAgain() {
      this.showCoin = false
      uiHelper.setCookie(SESSION.HIDE_COIN, 1, 0.5)
    },
    navigateToCoinPage() {
      this.$router.push({
        name: ROUTE_NAME.GRAB_COIN,
        params: {
          type: 'coin'
        }
      })
    },
    navigateWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      }
    },
    getWOF() {
      let currency = uiHelper.getCurrency()
      let filter = {
        currency: currency
      }
      this.$store.dispatch(`${WHEEL_MODULE}`, { filter })
    },
    getMemberDetail() {
      if (this.isLoggedIn) this.$store.dispatch(`${MEMBER_DETAIL}`)
    },
    goToAffilateProfilePage() {
      this.$router.push({
        name: ROUTE_NAME.AFFILIATE_LINK
      })
    },
    goToAffilateHomePage() {
      this.$router.push({
        name: ROUTE_NAME.AFFILIATE_HOME
      })
    },
    goToDepositPage() {
      if (uiHelper.getPlatform() == DevicePlatform.MOBILE) {
        let routeData = this.$router.resolve({
          name: ROUTE_NAME.DEPOSIT
        })
        window.open(routeData.href)
      } else {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT
        })
      }
    },
    getAnnouncement() {
      if (this.storageAnnouncement == null) {
        let obj = {
          site: uiHelper.getPlatform(),
          type: AnnouncementType.ALL,
          page: '',
          itemsPerPage: ''
        }
        this.$store.dispatch(`${ANNOUNCEMENT_LIST}`, { obj })
      } else {
        this.populateAnnouncement(this.storageAnnouncement)
      }
    },
    populateAnnouncement(announcementData) {
      let p = []
      announcementData.forEach(announcement => {
        p.push({
          id: announcement.id,
          date: announcement.announcementDate,
          title:
            announcement.titleLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.titleLocale.find(x => x.language == this.currentLanguage).title
              : announcement.titleLocale.find(x => x.language == 'en') != null
              ? announcement.titleLocale.find(x => x.language == 'en').title
              : announcement.titleLocale[0].title,
          message:
            announcement.messageLocale.find(x => x.language == this.currentLanguage) != null
              ? announcement.messageLocale.find(x => x.language == this.currentLanguage).message
              : announcement.messageLocale.find(x => x.language == 'en') != null
              ? announcement.messageLocale.find(x => x.language == 'en').message
              : announcement.messageLocale[0].message
        })
      })
      this.filteredAnnouncement = p
    },
    checkIncomingAction() {
      let action = this.$route.params.action

      if (action == SHARED.RESET_PASSWORD) {
        let memberCode = this.$route.params.memberCode
        let contact = this.$route.params.contact
        if (memberCode != null && memberCode != undefined && contact != null && contact != undefined) this.$parent.openResetPasswordDialog(memberCode, contact)
      } else if (action == SHARED.INFO_VERIFICATION) {
        let memberCode = this.$route.params.memberCode
        let otp = this.$route.params.otp
        let type = this.$route.params.type
        let contact = this.$route.params.contact
        if (memberCode != null && memberCode != undefined && otp != null && otp != undefined && type != null && type != undefined)
          this.$parent.memberContactVerification(memberCode, otp, type, contact)
      } else if (action == SHARED.REGISTER) {
        this.openRegisterDialog()
      }
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    }
  }
}
</script>
<style lang="scss">
.active_click {
  background-color: white;
}

.icon_gameHome {
  fill: white;
  color: black;
  stroke: #9c9ff3;
  width: 40px;
  height: 33px;
  padding-top: 4px;
}

.hooper-pagination {
  position: absolute;
  bottom: -6%;
  right: 52%;
  transform: translateX(52%);
  display: flex;
  padding: 5px 10px;

  ol.hooper-indicator {
    padding-left: 0;
  }
}

.hooper-indicator {
  width: 15px;
  height: 15px;
  border-radius: 10px;
}

.partner-box {
  height: 450px;
  position: relative;

  .partner-row {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;

    .partner-col {
      position: relative;

      .partner-title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .partner-desc {
        border-bottom: 4px solid var(--v-primary-base);
      }

      .partner-box-trophy {
        position: absolute;
        bottom: 0;
        right: 600px;
      }

      .partner-box-footballer {
        position: absolute;
        bottom: 0px;
        height: 420px;
        right: 100px;
        width: 800px;
      }
    }
  }
}

.joinInTheFun {
  border-bottom: 2px solid;
  border-color: var(--v-secondary-base);
  border-radius: 0px !important;
  cursor: pointer;
  color: var(--v-secondary-base);
  font-size: 16px;

  &:hover {
    border-color: var(--v-primary-base);
    color: var(--v-primary-base);
  }
}

.announcement-marquee-box {
  max-width: 1840px;
}

.home-announcment-content {
  p {
    margin-bottom: 0 !important;
  }
}

@media (max-width: 1650px) {
  .partner-box {
    .partner-row {
      .partner-col {
        .partner-box-trophy {
          right: 550px;
        }

        .partner-box-footballer {
          height: 380px;
          right: 80px;
        }
      }
    }
  }
}

@media (max-width: 1500px) {
  .partner-box {
    .partner-row {
      .partner-col {
        .partner-box-trophy {
          right: 360px;
          width: 280px;
        }

        .partner-box-footballer {
          height: auto;
          right: 50px;
          width: 600px;
        }
      }
    }
  }

  .joinInTheFun,
  .home-announcment-title,
  .home-announcment-content p {
    font-size: 15px;
  }
}

@media (max-width: 1350px) {
  .partner-box {
    height: 340px;

    .partner-row {
      .partner-col {
        .partner-title {
          width: 300px;
        }

        .partner-box-footballer {
          width: 500px;
        }

        .partner-box-trophy {
          right: 275px;
          width: 220px;
        }
      }
    }
  }
}

@media (max-width: 1263px) {
  .partner-box .partner-row .partner-col .partner-desc {
    font-size: 26px;
  }
  .joinInTheFun,
  .home-announcment-title,
  .home-announcment-content p {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .partner-box .partner-row .partner-col .partner-desc {
    font-size: 24px;
  }
}

@media (max-width: 959px) {
  .partner-box {
    height: 600px;
  }

  .partner-box .partner-row .partner-col.partner-box-message {
    height: 300px;
  }
  .partner-box .partner-row .partner-col.partner-box-image {
    height: 300px;
  }
}

@media (max-width: 599px) {
  .hooper-pagination {
    bottom: -3%;
  }

  .bg_home {
    .bg_filter {
      padding: 3% 3%;
    }
  }
  .partner-box {
    height: 300px;
  }
  .partner-box .partner-row .partner-col.partner-box-image {
    display: none;
  }
  .joinInTheFun,
  .home-announcment-title,
  .home-announcment-content p {
    font-size: 13px;
  }
}

@media (max-width: 425px) {
  .hooper-pagination {
    bottom: -5%;
  }
  // .v-badge__badge {
  //   bottom: 8px !important;
  // }
  .partner-box .partner-row .partner-col .partner-title {
    width: 220px;
  }
}

.wofClass {
  bottom: 20%;
  right: 0.5%;
  //z-index: 9999999;
  cursor: pointer;
  position: fixed;
}

.downloadClientClass {
  bottom: 30%;
  right: 0.5%;
  //z-index: 9999999;
  cursor: pointer;
  position: fixed;
}
</style>
